import { render, staticRenderFns } from "./ListOnBoarding.vue?vue&type=template&id=40bccb30&scoped=true&"
import script from "./ListOnBoarding.vue?vue&type=script&lang=ts&"
export * from "./ListOnBoarding.vue?vue&type=script&lang=ts&"
import style0 from "./ListOnBoarding.vue?vue&type=style&index=0&id=40bccb30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bccb30",
  null
  
)

export default component.exports